import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getCoreClipDetails, getCoreClipsDetails } from "./actions";

export const coreClipEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.contentId,
});

const initialState = coreClipEntityAdapter.getInitialState({});

export const coreClipSlice = createSlice({
  name: "coreClip",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoreClipDetails.fulfilled, (state, action) => {
      coreClipEntityAdapter.setOne(state, action.payload);
    });
    builder.addCase(getCoreClipsDetails.fulfilled, (state, action) => {
      const clipsDetails = Object.entries(action.payload?.data?.items || {}).map(([contentId, item]) => ({
        contentId,
        ...item,
      }));

      coreClipEntityAdapter.setAll(state, clipsDetails);
    });
  },
});

export default coreClipSlice.reducer;
